import React from "react"

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  siblingCount = 2, // how many pages to show on each side of current
}) {
  // build the sliding window of page numbers
  let start = Math.max(1, currentPage - siblingCount)
  let end = Math.min(totalPages, currentPage + siblingCount)

  // if we don't have enough pages after slicing, shift window
  if (end - start < siblingCount * 2) {
    start = Math.max(1, end - siblingCount * 2)
    end = Math.min(totalPages, start + siblingCount * 2)
  }

  const pages = []
  for (let p = start; p <= end; p++) pages.push(p)

  return (
    <div
      className="faxes-pagination"
      style={{ display: "flex", alignItems: "center", gap: "4px" }}
    >
      <button
        className="faxes-pagination-button"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        First
      </button>

      <button
        className="faxes-pagination-button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Prev
      </button>

      {pages.map((p) => (
        <button
          key={p}
          className={`faxes-pagination-button page${
            p === currentPage ? " active" : ""
          }`}
          onClick={() => onPageChange(p)}
        >
          {p}
        </button>
      ))}

      <button
        className="faxes-pagination-button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>

      <button
        className="faxes-pagination-button"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        Last
      </button>

      {/* <span className="faxes-page-info" style={{ marginLeft: "auto" }}>
        Page {currentPage} of {totalPages}
      </span> */}
    </div>
  )
}
